import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import ScrollIntoView from "../../../shared/scroll-into-view/scroll-into-view";
import {
    fetchAllSceneSettings,
    addAnimal,
    clearAnimal,
    clearRedirect,
    uploadImagesAndSaveAnimal,
    setNameAndSceneSetting,
    setSceneSetting,
    setReturnUrl
} from "./ducks/actions";
import Form from "./form";

function AddAnimal(props) {
    const filmId = props.filmId || props.match.params.filmId;
    const sceneId = props.sceneId || props.location?.state?.sceneId;
    const sceneSettingId = props.sceneSettingId || props.location?.state?.sceneSettingId;
    const returnUrl = props.location?.state?.returnUrl;
    const { addAnimal,
        animal,
        errors,
        uploadImagesAndSaveAnimal,
        setNameAndSceneSetting,
        name,
        embedded,
        clearAnimal,
        setReturnUrl,
        setSceneSetting,
        onCloseForm
    } = props;

    useEffect(() => {
        clearAnimal();
        props.fetchAllSceneSettings(filmId);
    }, []);

    useEffect(() => {
        if (name && sceneSettingId) {
            setNameAndSceneSetting(name, sceneSettingId);
        }
    }, [name, sceneSettingId]);

    useEffect(() => {
        if (!name && sceneSettingId) {
            setSceneSetting(sceneSettingId);
        }
    }, [sceneSettingId]);

    useEffect(() => {
        setReturnUrl(returnUrl);
    }, [returnUrl]);

    if (!embedded && props.redirect) {
        props.clearRedirect();
        let url;
        if (props.redirect.to === "list") {
            url = `/films/${filmId}/animals/`;
        } else if (props.redirect.to === "scenes") {
            url = `/films/${filmId}/animals/${props.redirect.id}/scenes/`;
        }
        return <Redirect to={url} />;
    }

    function onAddAnimal(animal) {
        animal.sceneId = sceneId;
        const files = animal.pictures || [];
        if (files && files.length > 0) {
            uploadImagesAndSaveAnimal(animal, files, true, filmId);
        } else {
            if (!animal.imageUrls) {
                animal.imageUrls = [];
            }
            addAnimal(filmId, animal);
        }
    }

    return (
        <ScrollIntoView
            className="blade-content widest"
            path="/films/:filmId/animals/add"
            loading={false}>
            <Form
                errors={errors}
                propId={null}
                initialValues={animal}
                loading={false}
                onSubmit={onAddAnimal}
                {...props}
                mode="add"
                acquisitionMethodEnum={props.acquisitionMethodEnum}
                reduxFormValues={props.reduxFormValues}
                allSceneSettings={props.allSceneSettings}
                onCloseForm={onCloseForm}
            />
        </ScrollIntoView>
    );
}

const mapStateToProps = (state) => {
    return {
        filmId: state.filmState.currentFilm.id,
        animal: state.animalsState.animal,
        errors: state.animalsState.errors,
        redirect: state.animalsState.redirect,
        acquisitionMethodEnum: state.enumState.acquisitionMethodEnum,
        allSceneSettings: state.animalsState.allSceneSettings,
        embedded: state.animalsState.embedded,
        name: state.animalsState.name,
        sceneSettingId: state.animalsState.sceneSettingId
    };
};

const mapDispatchToProps = {
    addAnimal,
    clearAnimal,
    clearRedirect,
    uploadImagesAndSaveAnimal,
    fetchAllSceneSettings,
    setNameAndSceneSetting,
    setSceneSetting,
    setReturnUrl
};

export default connect(mapStateToProps, mapDispatchToProps)(AddAnimal);
